import { render, staticRenderFns } from "./context_menu.vue?vue&type=template&id=1c56fd3d&scoped=true&"
import script from "./context_menu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./context_menu.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./context_menu.vue?vue&type=style&index=0&id=1c56fd3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c56fd3d",
  null
  
)

export default component.exports